import {addProcessing, removeProcessing} from "./processingActions";
import {
	CACHE_SERVICES,
	PROC_SERVICE_CREATE, PROC_SERVICE_DELETE,
	PROC_SERVICE_LIST,
	PROC_SERVICE_RELATIONS, PROC_SERVICE_UPDATE, PROC_SERVICE_UPDLOAD,
	UPDATE_SERVICES_LIST,
	UPDATE_SERVICES_RELATIONS
} from "./index";
import {addError} from "./errorActions";
import {DELETE, GET, POST, PUT, UPLOAD} from "ith-fetch";
import {SERVICE_ACTIONS} from "./types";
import {shouldUpdateExtend} from "ith-redux-helpers";
import isFunc from 'lodash/isFunction';

const _setListRelations = (list, relations, unset) => ({type: SERVICE_ACTIONS.SET_LIST_RELATIONS, list, relations, unset});
const _setList = list => ({type: SERVICE_ACTIONS.SET_LIST, list});
// const _updateList = list => ({type: SERVICE_ACTIONS.UPDATE_LIST, list});
const _setService = service => ({type: SERVICE_ACTIONS.SET_SERVICE, service});
const _setRelations = relations => ({type: SERVICE_ACTIONS.SET_RELATIONS, relations});
// const _addRelation = service => ({type: SERVICE_ACTIONS.ADD_RELATION, service});
const _setLogo = (service_id, logo = null) => ({type: SERVICE_ACTIONS.SET_LOGO, service_id, logo});

export const loadServices = (force=false, onSuccess) =>
	async (dispatch, getState) => {
		try {
			const target = getState().service;
			if ( !force && !shouldUpdateExtend(target, UPDATE_SERVICES_LIST, CACHE_SERVICES) && !shouldUpdateExtend(target, UPDATE_SERVICES_RELATIONS, CACHE_SERVICES)) {
				console.info('service list & relations are cached');
				return;
			}
			dispatch(addProcessing(PROC_SERVICE_LIST));
			dispatch(addProcessing(PROC_SERVICE_RELATIONS));
			const result = await GET('/services/all');
			// dispatch(_setRelations(result.relations));
			// dispatch(_setList(result.list));
			dispatch(_setListRelations(result.list, result.relations));
			onSuccess && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_SERVICE_LIST));
			dispatch(removeProcessing(PROC_SERVICE_RELATIONS));
		}
	};
export const createService = (data, onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_SERVICE_CREATE));
			const result = await PUT('/services', data);
			// if ( result.service.parent_id !== null ) {
			// 	dispatch(_addRelation(result.service));
			// }
			dispatch(_setService(result.service));
			onSuccess && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_SERVICE_CREATE));
		}
	};
export const moveService = (data, unset, onSuccess) =>
	async dispatch => {
		try {
			// dispatch(addProcessing(PROC_SERVICE_MOVEMENT));
			const result = await POST('/services/move', data);
			// dispatch(_setRelations(result.relations));
			// dispatch(_setList(result.list));
			dispatch(_setListRelations(result.list, result.relations, unset));
			onSuccess && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			// dispatch(removeProcessing(PROC_SERVICE_MOVEMENT));
		}
	};
export const deleteService = (service_id, all = false, onSuccess)  =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_SERVICE_DELETE));
			all = all ? '/all' : '';
			const result = await DELETE(`/services/${service_id}${all}`);
			dispatch(_setRelations(result.relations));
			dispatch(_setList(result.list));
			onSuccess && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_SERVICE_DELETE));
		}
	};
export const updateService = (service, onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_SERVICE_UPDATE, service.service_id));
			const result = await POST('/services', service);
			dispatch(_setService(result.service));
			onSuccess && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_SERVICE_UPDATE, service.service_id));
		}
	};
export const uploadLogoForService = (service, image, onSuccess) =>
	async dispatch => {
		const service_id = service.service_id || service;
		const data = new FormData();
		data.append('file', image);
		try {
			dispatch(addProcessing(PROC_SERVICE_UPDLOAD, service_id));
			const result = await UPLOAD('/services/logo/' + service_id, data);
			dispatch(_setService(result.service));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_SERVICE_UPDLOAD, service_id))
		}
	};
export const removeLogoOfService = (service, onSuccess) =>
	async dispatch => {
		const service_id = service.service_id || service;
		try {
			dispatch(addProcessing(PROC_SERVICE_UPDATE, service_id));
			const result = await DELETE('/services/logo/' + service_id);
			dispatch(_setLogo(result.service_id || service_id, null));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_SERVICE_UPDATE, service_id));
		}
	};

export const expandService = (expanded = false) => ({type: SERVICE_ACTIONS.EXPAND, expanded});
export const setService = _setService;


// WEBPACK FOOTER //
// ./src/actions/serviceActions.js